<template>
  <div v-if="goal.id" class="goal">
    <div class="goal__title">{{ goal.title }}</div>
    <div class="goal__amt-raised">Amount Raised</div>
    <div class="goal__small-description">
      {{ goal.receivedFunds | formatNumberAsUSDNoCents }} OUT OF
      {{ goal.targetFunds | formatNumberAsUSDNoCents }}
      <span v-if="goal.receivedFunds >= goal.targetFunds">- FUNDED!</span>
    </div>
    <ProgressBar :percent-complete="percentComplete" style="margin-bottom: 8px;" />
    <div v-if="goal.description" class="goal__small-description">
      By {{ goal.endDate | momentDateTime }}
    </div>
    <div v-if="goal.description" class="goal__description">{{ goal.description }}</div>
    <div class="box__row buttons-container">
      <!-- <button
        v-if="!hideDonateButton && !ownedByMe && goal.receivedFunds < goal.targetFunds"
        class="small-button small-button--inverted is-marginless"
        @click="onClickDonate"
      >
        Give
      </button> -->
      <form action="https://www.paypal.com/cgi-bin/webscr" method="post" target="_top">
        <input type="hidden" name="cmd" value="_s-xclick" />
        <input type="hidden" name="hosted_button_id" value="MGBGJPJ7D9ULN" />
        <input type="hidden" name="goal_id" :value="goal.id" />
        <input type="hidden" name="goal_title" :value="goal.title" />
        <input
          type="image"
          src="https://www.paypalobjects.com/en_US/i/btn/btn_donateCC_LG.gif"
          border="0"
          name="submit"
          title="PayPal - The safer, easier way to pay online!"
          alt="Donate with PayPal button"
        />
        <img
          alt=""
          border="0"
          src="https://www.paypal.com/en_KE/i/scr/pixel.gif"
          width="1"
          height="1"
        />
      </form>
      <router-link
        v-if="!hideDonateButton && !hideAllGoals"
        :to="{ name: 'GoalList', params: { projectId: project.id } }"
      >
        <button class="small-button small-button--inverted is-marginless" @click="onClickDonate">
          See All Goals
        </button>
      </router-link>
      <router-link
        v-if="ownedByMe"
        :to="{ name: 'EditGoal', params: { projectId: project.id, goalId: goal.id } }"
      >
        <button class="small-button is-marginless">Edit</button>
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'

import ProgressBar from '@/components/ProgressBar'

export default {
  name: 'GoalCard',
  components: {
    ProgressBar,
  },
  props: {
    goal: {
      type: Object,
      default: null,
    },
    hideDonateButton: {
      type: Boolean,
      default: false,
    },
    hideAllGoals: {
      type: Boolean,
      default: false,
    },
    ownedByMe: {
      type: Boolean,
      default: false,
    },
    project: {
      type: Object,
      default: null,
    },
  },
  computed: {
    percentComplete() {
      let percent = (this.goal.receivedFunds / this.goal.targetFunds) * 100
      if (percent >= 100) {
        percent = 100
      }
      return percent
    },
    ...mapGetters(['userIsLoggedIn']),
  },
  created() {
    this.goal.endDate = this.dateFormatForUI(this.goal.endDate)
  },
  methods: {
    onClickDonate() {
      // NIP 7/1/20 In preparation for site shutdown, redirect all attempted donations to a static page.
      window.location.href =
        'https://www.paypal.com/donate/?cmd=_s-xclick&hosted_button_id=HPSKX3WX74B4Q'
      // this.$router.push({
      //   name: 'GoalDonation',
      //   params: { projectId: this.project.id, goalId: this.goal.id, isCurrent: true },
      // })
    },
    dateFormatForUI(date) {
      //accounting for error "Invalid date" if endDate is unable to be coerced into specified format
      //will reset endDate to null if error occurs
      const dateFormatForUI = moment(date).format('YYYY-MM-DDTHH:mm')
      if (!dateFormatForUI || dateFormatForUI === 'Invalid date') {
        return null
      } else {
        return dateFormatForUI
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../styles/mixins/buttons';
@import '../styles/layout';

.goal {
  width: 100%;
  padding: 1rem 1.5rem;

  &__title {
    text-align: left;
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 10px;
  }

  &__amt-raised {
    text-align: left;
    font-size: 12px;
    font-weight: bold;
    line-height: 1.89;
    margin-bottom: 4px;
  }

  &__small-description {
    text-align: left;
    font-size: 12px;
    line-height: normal;
    color: $gray;
    margin-bottom: 8px;
  }

  &__description {
    text-align: left;
    font-size: 14px;
    line-height: normal;
    padding: 2px 4px 16px 0;
  }
}

.buttons-container {
  justify-content: space-around;
}

.is-marginless {
  margin: 0;
}
</style>
